import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const GLChildProfile = ({
  child,
  setChild,
  accessors,
  setAccessors,
  lang,
  saveChild,
  saveStatus,
  setSaveStatus,
}) => {
  const authState = useSelector((state) => state.authReducer || {});
  const [profileStatus, setProfileStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    if (!authState?.user) return;

    setAccessors((prev) => ({
      ...prev,
      parentCode: prev.parentCode || authState.user.think5whyscode || "",
    }));
  }, [authState, setAccessors]);

  const handleChildChange = (key, value) => {
    setChild((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="flex justify-center py-2">
      <div className="w-full max-w-md space-y-3">
        <h2 className="text-sm font-bold text-cyan-300">
          {lang === "hi" ? "बच्चे का विवरण" : "Child Details"}
        </h2>
        {!child?._id && (
          <div className="mb-3 rounded-lg border border-yellow-600 bg-yellow-900/20 px-4 py-3 text-sm text-yellow-300">
            {lang === "hi"
              ? "कोई चाइल्ड प्रोफ़ाइल नहीं! अपनी एक चाइल्ड प्रोफ़ाइल बनाएं।"
              : "No child profile! Create your one child profile."}
          </div>
        )}
        <input
          className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500"
          placeholder={lang === "hi" ? "बच्चे का नाम" : "Child Name"}
          value={child.name || ""}
          onChange={(e) => handleChildChange("name", e.target.value)}
        />

        <input
          className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500"
          placeholder={lang === "hi" ? "आयु" : "Age"}
          value={child.age || ""}
          onChange={(e) => handleChildChange("age", e.target.value)}
        />

        <input
          className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500"
          placeholder={lang === "hi" ? "कक्षा" : "Grade / Class"}
          value={child.grade || ""}
          onChange={(e) => handleChildChange("grade", e.target.value)}
        />

        <div className="grid grid-cols-2 gap-2">
          <input
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
            placeholder="GLM Code"
            value={child.glmCode || ""}
            onChange={(e) => handleChildChange("glmCode", e.target.value)}
          />

          <input
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
            placeholder="GLP Code"
            value={child.glpCode || ""}
            onChange={(e) => handleChildChange("glpCode", e.target.value)}
          />

          <input
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
            placeholder="GLE Code"
            value={child.gleCode || ""}
            onChange={(e) => handleChildChange("gleCode", e.target.value)}
          />

          <input
            className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
            placeholder="GLD Code"
            value={child.gldCode || ""}
            onChange={(e) => handleChildChange("gldCode", e.target.value)}
          />
        </div>

        <input
          className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-1 text-xs text-white placeholder-gray-500"
          placeholder="Parent Think5Whys Code"
          value={accessors.parentCode || ""}
          onChange={(e) =>
            setAccessors((prev) => ({
              ...prev,
              parentCode: e.target.value,
            }))
          }
        />

        <button
          onClick={async () => {
            const res = await saveChild({
              ...child,
              parentCode: accessors.parentCode,
              educatorCodes: accessors.educatorCodes,
              doctorCodes: accessors.doctorCodes,
              externalCodes: accessors.externalCodes,
            });

            if (res?.success) {
              setChild(res.data);
            }
          }}
          className="w-full bg-cyan-600 text-black rounded-lg py-2 text-xs font-bold"
        >
          {lang === "hi"
            ? "बच्चे की प्रोफ़ाइल सहेजें"
            : "Save/Update Child Profile"}
        </button>
        {profileStatus.message && (
          <p
            className={`text-xs mt-2 ${profileStatus.type === "success" ? "text-green-400" : "text-red-400"}`}
          >
            {profileStatus.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default GLChildProfile;
